module.exports = __webpack_public_path__ + "static/media/cocina.3f6e96e8.png";